export default __webpack_public_path__ + "static/profile-pic-fab96be017278fddfbc02ed916931012.png";